import { call, put, takeLatest } from "redux-saga/effects";
import { callAPI, handleError, handleSuccess } from "../api/api";
import { setLoaderAction, setNotificationAction } from "../reducers/mmymSlice";
import {
  addSignOffTaskAction,
  getAllSignOffTasks,
  setAddSignOffTaskResponse,
  setAllSignOffTasks,
} from "../reducers/signOffTaskSlice";
/**
 * This function for call the user profile
 *
 * @param {*} payload
 */

function* getAllSignOffTasksSaga(payload :any ): any {
  yield put(setLoaderAction(true));
  const {startDate, endDate} = payload.payload;
  try {
    const res = yield call<any>(callAPI, {}, "get", `leads/task-sign-off?startDate=${startDate}&endDate=${endDate}`);
    console.log("plans-", res);
    if (res?.data) {
      yield put(setAllSignOffTasks(res?.data));
    }
  } catch (error) {
    console.log("Catch Error-", error);
  }
  yield put(setLoaderAction(false));
}

function* addSignOffTaskActionSaga(payload:any[]): any {
  yield put(setLoaderAction(true));
  yield put(setNotificationAction({ message: [], severity: "error" }));
  console.log("addSignOffTaskActionSaga payload-", payload);
  try {
    const apiResponse = yield call<any>(
      callAPI,
      payload,
      "post",
      "leads/task-sign-off"
    );
    if (apiResponse?.success === true) {
      apiResponse && handleSuccess(apiResponse);
      yield put(setAddSignOffTaskResponse(true));
      yield put(setNotificationAction({ message: [], severity: "success" }));
    }
  } catch (error: any) {
    console.log("Catch Error-", error);
    error?.response && handleError(error?.response);
    error?.code === "ERR_NETWORK" && handleError(error);
  }
  yield put(setLoaderAction(false));
}

export function* watchSignOffTask() {
  yield takeLatest<any>(getAllSignOffTasks, getAllSignOffTasksSaga);
  yield takeLatest<any>(addSignOffTaskAction, addSignOffTaskActionSaga);
}
